import { LANDING_STORY_SECTIONS } from "./landingStoryContent";
import LandingStoryFeatureVisual from "./LandingStoryFeatureVisual";
import s from "./homeLanding.module.css";

function StoryBullets({ items }) {
  return (
    <ul className={s.storyBullets}>
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

function StoryVisual({ section }) {
  if (section.layout === "features") {
    return <LandingStoryFeatureVisual section={section} />;
  }
  return null;
}

function StoryBlock({ section, index }) {
  const reverse = section.reverse ?? index % 2 === 1;

  return (
    <article
      id={`story-${section.id}`}
      className={`${s.storyBlock} ${reverse ? s.storyBlockReverse : ""}`}
    >
      <div className={s.storyCopy}>
        <p className={s.storyEyebrow}>{section.eyebrow}</p>
        <h3 className={s.storyTitle}>{section.title}</h3>
        <p className={s.storyLead}>{section.lead}</p>
        <StoryBullets items={section.bullets} />
      </div>
      <div className={s.storyVisual}>
        <StoryVisual section={section} />
      </div>
    </article>
  );
}

export default function LandingStorySections({ sectionIds } = {}) {
  const sections = Array.isArray(sectionIds)
    ? LANDING_STORY_SECTIONS.filter((s) => sectionIds.includes(s.id))
    : LANDING_STORY_SECTIONS;
  return (
    <section id="showcase" className={`${s.section} ${s.sectionStory}`}>
      <div className={s.storyStack}>
        {sections.map((section, index) => (
          <StoryBlock key={section.id} section={section} index={index} />
        ))}
      </div>
    </section>
  );
}
